export const FONT = {
  PRIMARY: [
    'Raleway',
    'system-ui',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    '"Fira Sans"',
    '"Droid Sans"',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
  ],
  SECONDARY: [
    'Inter',
    'system-ui',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    'Arial',
    'sans-serif',
  ],
  MONOSPACE: ['"Oxygen Mono"', '"Roboto Mono"', '"Courier New"', 'Courier', 'monospace'],
};
